import { render, staticRenderFns } from "./LeadsCardData.vue?vue&type=template&id=121a0c0e&scoped=true&"
import script from "./LeadsCardData.vue?vue&type=script&lang=js&"
export * from "./LeadsCardData.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardData.vue?vue&type=style&index=0&id=121a0c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a0c0e",
  null
  
)

export default component.exports